import { Heading, Bubble } from '@frontendmentorio/design-system-v2';

export default function Card({ children, icon, heading }) {
  return (
    <div className="bg-blue-500 container-md flex flex-col gap-4 items-center pb-6 pt-7 px-5 relative rounded-xl">
      <Bubble className="absolute-center-x bg-blue-600 top-[-2rem]">
        {icon}
      </Bubble>

      <div className="flex flex-col gap-4 max-w-prose text-center text-white">
        <Heading level="2">{heading}</Heading>

        <p>{children}</p>
      </div>
    </div>
  );
}
